import { iso } from './formato';

// Periodos que ofrecen las pantallas de ventas de Punto V.
export const PERIODOS = [
  { id: 'hoy', etiqueta: 'Hoy' },
  { id: 'mes_anterior', etiqueta: 'Mes anterior' },
  { id: 'mes_actual', etiqueta: 'Este mes' },
  { id: '30', etiqueta: 'Últimos 30 días' },
  { id: '90', etiqueta: 'Últimos 90 días' },
  { id: 'rango', etiqueta: 'Rango…' }
];

// [desde, hasta] en AAAA-MM-DD para un periodo predefinido.
export const rangoDe = (periodo) => {
  const hoy = new Date();
  if (periodo === 'hoy') return [iso(hoy), iso(hoy)];
  if (periodo === 'mes_actual') return [iso(new Date(hoy.getFullYear(), hoy.getMonth(), 1)), iso(hoy)];
  if (periodo === 'mes_anterior') {
    return [iso(new Date(hoy.getFullYear(), hoy.getMonth() - 1, 1)), iso(new Date(hoy.getFullYear(), hoy.getMonth(), 0))];
  }
  const dias = Number(periodo);
  return [iso(new Date(hoy.getFullYear(), hoy.getMonth(), hoy.getDate() - dias + 1)), iso(hoy)];
};

// AAAA-MM si el rango cae dentro de un solo mes (para la mensualidad).
export const mesDelRango = (desde, hasta) => (
  desde && hasta && desde.slice(0, 7) === hasta.slice(0, 7) ? desde.slice(0, 7) : null
);
